export const PERSONAL_INFO_SECTION = 'personal-info';
export const FINANCIAL_INFO_SECTION = 'financial-info';
export const OUTLINE_OF_CREDIT = 'outline-of-credit';
export const PERSONAL_ELIGIBILITY_SECTION = 'personal-eligibility-section';

